import store from '@/store'
import { ref, computed } from '@vue/composition-api'
import { formhttp, useRouter } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default () => {
  const toast = useToast()
  const { route } = useRouter()
  const useShowHowMany = ref(false) // * Indicates if will be cutted an array to limit data

  // * Notification filters
  const filters = ref({
    folder: 'unread',
    priority: null,
    destiny: null,
    isSortDesc: true,
  })

  // * Return notifications from store
  const notificaciones = computed(() => store.getters['notificaciones/notificaciones'](filters.value, useShowHowMany.value))

  // * Retorna la cantidad de notificaciones que hay por tipo [read, unread, all]
  const notificacionesMeta = computed(() => store.getters['notificaciones/notificacionesMeta'])

  // * Return and update alert flag
  const showAlert = computed({
    get: () => store.state.notificaciones.config.showAlert,
    set: newValue => store.dispatch('notificaciones/changeShowAlert', newValue),
  })

  // * Return and update how many items to show
  const showHowMany = computed({
    get: () => store.state.notificaciones.config.howManyToShow,
    set: newValue => store.dispatch('notificaciones/changeHowMany', newValue),
  })

  // * Return and update how many items to show
  const howManyAlerts = computed({
    get: () => store.state.notificaciones.config.howManyAlerts,
    set: newValue => store.dispatch('notificaciones/changeHowManyAlerts', newValue),
  })

  // * Return and update loader flag
  const showLoader = computed({
    get: () => store.state.notificaciones.showLoader,
    set: newValue => store.dispatch('notificaciones/showLoader', newValue),
  })

  // * Total notifications
  const total = computed(() => notificaciones.value.length)

  // * Load new notifications by user's group
  const loadNotifications = () => {
    showLoader.value = true
    store.dispatch('notificaciones/getNotifications')
      .then(response => {
        showLoader.value = false

        if (showAlert.value && route.value.name !== 'user-notification' && route.value.name !== 'user-notification-detail') {
          if (!notificaciones.value.length) {
            const { label } = formhttp(response.status)
            toast({
              component: ToastificationContent,
              props: {
                title: 'Notificaciones',
                text: response.message,
                icon: 'BellIcon',
                variant: label,
              },
            },
            { timeout: 8000 })
          } else if (notificaciones.value.length > howManyAlerts.value) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Notificaciones',
                text: `Tienes más de ${howManyAlerts.value} notificaciones sin leer`,
                icon: 'BellIcon',
                variant: 'warning',
              },
            },
            { timeout: 8000 })
          } else {
            for (let i = 0; i < notificaciones.value.length; i += 1) {
              setTimeout(() => {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Nueva notificación',
                    text: notificaciones.value[i].titulo,
                    icon: 'BellIcon',
                    variant: 'warning',
                  },
                },
                { timeout: 13000 })
              }, `${i}000`)
            }
          }
        }
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error cargando notificaciones',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
  }

  // * Mark notification as 'read' or 'unread'
  const markAs = id => {
    showLoader.value = true
    store.dispatch('notificaciones/markAs', id)
      .then(response => {
        showLoader.value = false

        if (response.status === 200) loadNotifications()
        else {
          const { label } = formhttp(response.status)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Marcar notificación',
              text: response.message,
              icon: 'BellIcon',
              variant: label,
            },
          },
          { timeout: 8000 })
        }
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error marcando notificación',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
  }

  return {
    // Method
    loadNotifications,
    markAs,

    // Computed
    showAlert,
    showHowMany,
    howManyAlerts,
    total,
    notificacionesMeta,

    // Data
    notificaciones,
    filters,

    // Flag
    showLoader,
    useShowHowMany,
  }
}
